import React, { useState } from 'react';
import { Divider, Nav } from 'rsuite';
import { fetchSinToken } from '../../../helpers/fetch';
import { Botones } from './Step5';
import { Practicaja } from './pagos/Practicaja';
import { Spei } from './pagos/Spei';
import { Tienda } from './pagos/Tienda';

export const Step4Pago = ({cliente, setCliente, handleNext}) => {
    const [tipoPago, setTipoPago] = useState('')
    const [btnLoading, setBtnLoading] = useState(false);


    const renderComponent = () =>{
        switch ( tipoPago ) {
            case 'transferencia':   return <Spei cliente={cliente} handleGenerarFicha={handleGenerarFicha} btnLoading={btnLoading}/>
            case 'comercio':        return <Tienda cliente={cliente} handleGenerarFicha={handleGenerarFicha} btnLoading={btnLoading}/>
            case 'practicaja':      return <Practicaja cliente={cliente} handleGenerarFicha={handleGenerarFicha} btnLoading={btnLoading}/>
        }
    }

    const handleGenerarFicha = async (tipo) =>{
        setBtnLoading(true);
        let data = `id=${cliente.cliente_id}`;
        data += `&type=${tipo}`;
        const resp = await fetchSinToken(`preregistro/pagos/efectivo`, data, 'POST');
        const body = await resp.json();
        if(body.ok){
            setCliente(e => ({
                ...e,
                payment_id: body.pago.payment_id,
                method: body.pago.method
            }));
            handleNext();
        }
        setBtnLoading(false)
    }

    return (
        <div className="row">
            <div className="col-12">
                <div className="text-center">
                    <h2 className="mt-0">
                        <i className="fa fa-globe fa-1x"></i>
                    </h2>
                    <h3 className="mt-0">Falta Poco!</h3>

                    <p className="mb-2 mx-auto">Para finalizar selecciona un metodo de pago para tu anticipo de { new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(cliente.anticipo) }.</p>
                    <p className="mb-2 text-left">Una vez generada tu ficha de pago podrás imprimirla, de igual manera te enviaremos una copia por correo electrónico. <br/> Si después de unos minutos no llegada tu ficha por correo, te sugerimos buscar en el apartado de <strong>correos no deseados</strong> o <strong>spam</strong> y marcarlo con el botón <strong>"No es un correo no deseado"</strong> para  enviarte el recibo de tus pagos y otros mensajes importantes referentes a tu plan de viaje.</p>
                    <div className="card">
                        <div className="card-body">
                            <div className="mb-3">
                                <Nav appearance="subtle">
                                    <Nav.Item active={tipoPago === 'transferencia'} onClick={() => setTipoPago('transferencia')}>Transferencias</Nav.Item>
                                    <Divider vertical style={{height: '3em'}}/>
                                    <Nav.Item active={tipoPago === 'comercio'} onClick={() => setTipoPago('comercio')}>Comercios</Nav.Item>
                                    <Divider vertical style={{height: '3em'}}/>
                                    <Nav.Item active={tipoPago === 'practicaja'} onClick={() => setTipoPago('practicaja')}>Practicaja BBVA</Nav.Item>
                                    {/* <Nav.Item disabled>Tarjeta</Nav.Item> */}
                                </Nav>
                            </div>
                            {renderComponent()}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
